import { Enviroments } from './entities'

const buildTraceSampleRate = (env: Enviroments) => {
  const rates = new Map()
  rates.set('local', 1)
  rates.set('development', 1)
  rates.set('production', 0.2)
  rates.set('sailfish', 0.2)
  return rates.get(env) ?? 0
}

export default buildTraceSampleRate
